export default "__VITE_PUBLIC_ASSET__7296c35a__"